import React from 'react';
import { createRoot } from 'react-dom/client';
// import './index.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import reportWebVitals from './reportWebVitals';

import './Scss/main.scss';
import './i18n';
import App from './App';
import ErrorBoundary from './Components/ErrorBoundary';

import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <PostHogProvider client={posthog}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </PostHogProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
